import React, { useCallback, useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useOutletContext } from 'react-router';
import { toast } from 'react-toastify';
import { API } from 'utilities/api';
import { CONTENT_TOP } from 'dashboard/layouts/admin/chromeGeometry';
import { EmptyState, PageHeader, PagePaper, folderTabs } from 'dashboard/components/common';
import DiaryTab from './DiaryTab';
import ResourcesTab from './ResourcesTab';

/**
 * Bookings.
 *
 * Two tabs, and the diary is first because it is the one opened every morning.
 * Setting up what can be booked is done once and then rarely — putting it
 * first would cost the daily user a click every day to save the occasional
 * user one.
 */
export default function Bookings() {
  const [selectedBrand] = useOutletContext();
  const [tab, setTab] = useState(0);
  const [resources, setResources] = useState([]);

  const loadResources = useCallback(() => {
    if (!selectedBrand) { setResources([]); return; }
    API.listBookableResources({ brand_id: selectedBrand })
      .then((res) => setResources(Array.isArray(res) ? res : []))
      .catch((err) => toast.error(err?.message || 'Could not load what can be booked'));
  }, [selectedBrand]);

  useEffect(() => { loadResources(); }, [loadResources]);

  return (
    <Box sx={{ pt: CONTENT_TOP }}>
      <PagePaper>
        <PageHeader
          title='Bookings'
          subtitle='Who is coming, and what people can book.'
        />

        {!selectedBrand ? (
          <EmptyState>Select a brand to manage bookings.</EmptyState>
        ) : (
          <Box>
            <Tabs value={tab} onChange={(_e, v) => setTab(v)} sx={{ ...folderTabs, mb: '16px' }}>
              <Tab label='Diary' />
              <Tab label='What can be booked' />
            </Tabs>
            {tab === 0 && <DiaryTab brandId={selectedBrand} resources={resources} />}
            {tab === 1 && (
              <ResourcesTab
                brandId={selectedBrand}
                resources={resources}
                onChanged={loadResources}
              />
            )}
          </Box>
        )}
      </PagePaper>
    </Box>
  );
}
